import { render, staticRenderFns } from "./EpgModal.vue?vue&type=template&id=88917c0a"
import script from "./EpgModal.vue?vue&type=script&lang=ts"
export * from "./EpgModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports